import styles from './PresenceBar.module.css';

export interface PresenceEntry {
  userId: string;
  displayName: string;
  status: 'viewing' | 'composing:text' | 'composing:photo' | 'composing:audio' | 'composing:video';
  since: string;
}

const AUTHOR_COLORS = [
  'var(--st-author-1)', 'var(--st-author-2)', 'var(--st-author-3)',
  'var(--st-author-4)', 'var(--st-author-5)', 'var(--st-author-6)',
  'var(--st-author-7)', 'var(--st-author-8)', 'var(--st-author-9)',
  'var(--st-author-10)',
];

function getInitials(name: string): string {
  return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

function getColor(index: number): string {
  return AUTHOR_COLORS[index % AUTHOR_COLORS.length];
}

function getComposingLabel(entries: PresenceEntry[]): string | null {
  const composing = entries.filter(e => e.status.startsWith('composing:'));
  if (composing.length === 0) return null;
  if (composing.length === 1) return `${composing[0].displayName} is typing...`;
  return `${composing.length} people typing...`;
}

interface PresenceBarProps {
  entries: PresenceEntry[];
}

export function PresenceBar({ entries }: PresenceBarProps) {
  if (entries.length === 0) return null;

  const composingLabel = getComposingLabel(entries);

  return (
    <div class={styles.container}>
      <span class={styles.dot} aria-hidden="true" />
      <div class={styles.avatars}>
        {entries.slice(0, 5).map((entry, i) => (
          <div
            key={entry.userId}
            class={`${styles.avatar} ${entry.status.startsWith('composing:') ? styles.composing : ''}`}
            style={{ background: getColor(i) }}
            title={entry.displayName}
          >
            {getInitials(entry.displayName)}
          </div>
        ))}
        {entries.length > 5 && (
          <div class={styles.overflow}>+{entries.length - 5}</div>
        )}
      </div>
      <span class={styles.label}>
        {composingLabel ?? `${entries.length} ${entries.length === 1 ? 'person' : 'people'} here now`}
      </span>
    </div>
  );
}
